module.exports = __webpack_public_path__ + "static/TlwgTypewriter-Oblique-bc4ef4a5d7ddcf1ba6f43d17432d33c7.woff";